import { APOffer } from "@/apps/tatar/activityApp/views/details/offer-feature/APOffer.Interface";
import React from "react";
import {
  APOfferVacancyMeta,
  VacancyDigitalSignActionLog,
} from "../../../model/VacancyApplicant.interface";
import i18n from "@/i18n";
import VerticalProcessHistoryEntry from "@/components/VerticalProcessHistory/VerticalProcessHistoryEntry";
import "./VacancyContractActionLog.scss";

type Props = {
  offer: APOffer;
};

const VacancyContractActionLog = (props: Props) => {
  const { offer } = props;
  const offerMeta = offer.data.meta as APOfferVacancyMeta;

  const actionLog = offerMeta.actionLog || [];

  return (
    <div className="vacancy-contract-action-log">
      {actionLog.map((actionLogEntry, i) => {
        return (
          <div
            key={actionLogEntry.time.toString()}
            className="action-log-entry-container"
          >
            <VacancyContractActionLogEntry actionLogEntry={actionLogEntry} />
          </div>
        );
      })}
    </div>
  );
};

export default VacancyContractActionLog;

type VacancyContractActionLogEntryProps = {
  actionLogEntry: VacancyDigitalSignActionLog;
};

export const VacancyContractActionLogEntry = (
  props: VacancyContractActionLogEntryProps
) => {
  const { actionLogEntry } = props;

  return (
    <div>
      <VerticalProcessHistoryEntry
        entry={{
          dateFormat: i18n.t("Formats.dateTimeFormat"),
          subLabel: actionLogEntry.name,
          date: actionLogEntry.time,
          label:
            actionLogEntry.event === "Signed"
              ? i18n.t(
                  "apTemplate:Vacancy.Applicant.ContractDetails.Label.ActionLog.Signed",
                  "Unterschrieben"
                )
              : i18n.t(
                  "apTemplate:Vacancy.Applicant.ContractDetails.Label.ActionLog.Viewed",
                  "Angesehen"
                ),
          icon: {
            type: "light",
            data:
              actionLogEntry.event === "Signed" ? "signature-sign" : "view-1",
          },
          backgroundColor:
            actionLogEntry.event === "Signed" ? "#e6f4ea" : "#fff4e5",
          color: actionLogEntry.event === "Signed" ? "#1f7a4c" : "#b26a00",
          type: "past",
        }}
      />
    </div>
  );
};
